import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import { themes, leaveCreditingShedule } from "services/constants";
import dayjs from "dayjs";
import { monthNumber } from "pages/HR/Headers";
import { Info } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import { formKeyText, tableData, formHeader } from "services/constants/Styles";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { CustomTextBox } from "components/CustomComponents/CustomTextBox";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { scheduleMultiplier } from "pages/HR/Headers";
import { customAPI } from "services/utils/CustomAPI";
import { tooltipStyleProps } from "services/constants/Styles";
const leavePayout = [
  { label: "Pay out at the end of leave period" },
  { label: "Accumulate and payout at year end" },
  { label: "Accumulate and expire at year end" },
  { label: "Accumulate and carry forward" },
];

export const EditLeaveTypeConfig = ({
  viewDetails,
  editLeaveTypeDetails,
  setEditLeaveType,
  setApiCall,
}) => {
  const { domain } = useSelector((state) => state.tokenReducer);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [leavePayoutPolicyName, setLeavePayoutPolicy] = useState("");
  const [leaveCreditingSheduleData, setLeaveCreditingSheduleData] =
    useState("Annually");
  const [proportionate, setProportionate] = useState(false);
  const [carryForwardDays, setCarryForwardDays] = useState("");
  const [paymentFactor, setPaymentFactor] = useState(0);
  const [annualLeaveCount, setAnnualLeaveCount] = useState(0);
  const [isPaidLeave, setIsPaidLeave] = useState(false);
  const [updateDefaultValue, setUpdateDefaultValue] = useState(true);

  const {
    register,
    reset,
    handleSubmit,
    clearErrors,
    unregister,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      is_week_off_rule_apply: false,
      week_off_rule_type: "before",
      is_holiday_rule_apply: false,
      holiday_off_rule_type: "before",
    },
  });

  useEffect(() => {
    if (updateDefaultValue) {
      setValue(
        "leave_crediting_schedule",
        editLeaveTypeDetails?.leave_crediting_schedule
      );
      setLeaveCreditingSheduleData(
        editLeaveTypeDetails?.leave_crediting_schedule
      );
      setProportionate(
        editLeaveTypeDetails?.proportionate_leaves_on_joined_date
      );
      setLeavePayoutPolicy(editLeaveTypeDetails?.leave_pay_out_policy);
      setPaymentFactor(editLeaveTypeDetails?.payment_factor);
      setValue(
        "leave_pay_out_policy",
        editLeaveTypeDetails?.leave_pay_out_policy
      );
      setValue(
        "leave_per_leave_period",
        editLeaveTypeDetails?.leave_per_leave_period
      );
      setValue("effective_from", editLeaveTypeDetails?.effective_from);
      setUpdateDefaultValue(false);
      setValue(
        "no_of_days_leave_carry_forward",
        editLeaveTypeDetails?.no_of_days_leave_carry_forward
      );
      setCarryForwardDays(editLeaveTypeDetails?.no_of_days_leave_carry_forward);
      setValue("expiry_month", editLeaveTypeDetails?.expiry_month);
      setValue(
        "pre_ver_effective_to",
        dayjs(
          editLeaveTypeDetails?.pre_version_data?.pre_ver_effective_to
        ).format("DD-MM-YYYY")
      );
      setValue("min_days_to_apply", editLeaveTypeDetails?.min_days_to_apply);
      setValue(
        "enable_leave_crediting",
        editLeaveTypeDetails?.enable_leave_crediting
      );
      setValue(
        "is_week_off_rule_apply",
        editLeaveTypeDetails?.is_week_off_rule_apply || false
      );
      setValue(
        "week_off_rule_type",
        editLeaveTypeDetails?.week_off_rule_type || "before"
      );
      setValue(
        "is_holiday_rule_apply",
        editLeaveTypeDetails?.is_holiday_rule_apply || false
      );
      setValue(
        "holiday_off_rule_type",
        editLeaveTypeDetails?.holiday_off_rule_type || "before"
      );
      setIsPaidLeave(editLeaveTypeDetails?.is_paid_leave);
      setAnnualLeaveCount(
        parseFloat(
          parseFloat(editLeaveTypeDetails?.leave_per_leave_period || 0) *
            (editLeaveTypeDetails?.enable_leave_crediting
              ? scheduleMultiplier[
                  editLeaveTypeDetails?.leave_crediting_schedule
                ] || 1
              : 1)
        ).toFixed(2)
      );
    }
  }, [
    editLeaveTypeDetails?.effective_from,
    editLeaveTypeDetails?.enable_leave_crediting,
    editLeaveTypeDetails?.expiry_month,
    editLeaveTypeDetails?.holiday_off_rule_type,
    editLeaveTypeDetails?.is_paid_leave,
    editLeaveTypeDetails?.is_holiday_rule_apply,
    editLeaveTypeDetails?.is_week_off_rule_apply,
    editLeaveTypeDetails?.leave_crediting_schedule,
    editLeaveTypeDetails?.leave_pay_out_policy,
    editLeaveTypeDetails?.leave_per_leave_period,
    editLeaveTypeDetails?.min_days_to_apply,
    editLeaveTypeDetails?.no_of_days_leave_carry_forward,
    editLeaveTypeDetails?.payment_factor,
    editLeaveTypeDetails?.pre_version_data?.pre_ver_effective_to,
    editLeaveTypeDetails?.proportionate_leaves_on_joined_date,
    editLeaveTypeDetails?.week_off_rule_type,
    isPaidLeave,
    setValue,
    updateDefaultValue,
  ]);

  const createLeaveType = async (data) => {
    setButtonLoader(true);
    const payload = {
      pre_ver_effective_to: data?.pre_ver_effective_to
        ?.split("-")
        .reverse()
        .join("-"),
      leave_type: viewDetails?.id,
      version: editLeaveTypeDetails?.version,
      effective_from: data?.effective_from,
      proportionate_leaves_on_joined_date: proportionate,
      is_paid_leave: isPaidLeave,
      ...(isPaidLeave ? { payment_factor: data?.payment_factor } : {}),
      leave_per_leave_period: data?.leave_per_leave_period,
      enable_leave_crediting: data?.enable_leave_crediting,
      leave_crediting_schedule: data?.enable_leave_crediting
        ? data?.leave_crediting_schedule
        : null,
      is_week_off_rule_apply: data?.is_week_off_rule_apply,
      week_off_rule_type: data?.is_week_off_rule_apply
        ? data?.week_off_rule_type
        : null,
      is_holiday_rule_apply: data?.is_holiday_rule_apply,
      holiday_off_rule_type: data?.is_holiday_rule_apply
        ? data?.holiday_off_rule_type
        : null,
      total_annual_leaves: annualLeaveCount,
      leave_pay_out_policy: data?.enable_leave_crediting
        ? data?.leave_pay_out_policy
        : null,
      no_of_days_leave_carry_forward: data?.enable_leave_crediting
        ? data?.no_of_days_leave_carry_forward
        : null,
      expiry_month: data?.enable_leave_crediting ? data?.expiry_month : null,
      min_days_to_apply: data?.min_days_to_apply,
    };
    const response = await customAPI(
      `${domain}configuration-leave-type/${editLeaveTypeDetails?.id}/`,
      "PUT",
      payload
    );
    if (response.ok) {
      setEditLeaveType(false);
      showToast("success", "Leave Type updated.");
      setApiCall(true);
      reset();
      setButtonLoader(false);
    } else {
      setButtonLoader(false);
    }
  };

  const handleKeyPress = (e) => {
    const charCode = e.charCode;
    if ((charCode < 48 || charCode > 57) && charCode !== 46) {
      e.preventDefault();
    }
  };

  const handleKeyPressWithYear = (e) => {
    const charCode = e.charCode;
    if ((charCode < 48 || charCode > 57) && charCode !== 46) {
      e.preventDefault();
    }
  };

  const updateLeavePayoutPolicy = (event, data) => {
    if (data) {
      if (data?.label === "Accumulate and carry forward") {
        setValue("no_of_days_leave_carry_forward", "");
        setValue("leave_pay_out_policy", data?.label);
        setLeavePayoutPolicy(data?.label);
      } else {
        setValue("no_of_days_leave_carry_forward", 0);
        setValue("expiry_after", 0);
        clearErrors(["expiry_after", "no_of_days_leave_carry_forward"]);
        unregister(["expiry_after", "no_of_days_leave_carry_forward"]);
        setValue("leave_pay_out_policy", data?.label);
        setLeavePayoutPolicy(data?.label);
      }
    }
  };

  const updateProportionate = () => {
    setProportionate(!proportionate);
  };

  const updateCarryForwardDays = (event) => {
    const value = event.target.value;
    if (value === "" || value === "-") {
      setCarryForwardDays(value);
      setValue("no_of_days_leave_carry_forward", value);
      return;
    }
    if (/^-?\d+(\.5?)?$/.test(value) && parseInt(value) <= 999) {
      setCarryForwardDays(value);
      setValue("no_of_days_leave_carry_forward", value);
    }
  };

  const handlePaidLeaveOrNot = (value) => {
    setIsPaidLeave(value?.target?.checked);
  };

  const handleLeaveCreditingSchedule = (event, data) => {
    if (data) {
      setLeaveCreditingSheduleData(data?.label);
      setValue("leave_crediting_schedule", data?.label);
      setValue("leave_per_leave_period", 0);
      setAnnualLeaveCount(0);
    } else {
      setLeaveCreditingSheduleData("");
      setValue("leave_crediting_schedule", "");
      setValue("leave_per_leave_period", 0);
      setAnnualLeaveCount(0);
    }
  };

  const updateExpireDetails = (event, data) => {
    if (data) {
      setValue("expiry_month", data?.label);
    }
  };

  const updateEnableLeaveCrediting = (value) => {
    setValue("enable_leave_crediting", value?.target?.checked);
    if (!value?.target?.checked) {
      setValue("leave_crediting_schedule", "Annually");
      setValue("leave_per_leave_period", 0);
      setValue("leave_pay_out_policy", "Accumulate and payout at year end");
      clearErrors([
        "leave_crediting_schedule",
        "leave_per_leave_period",
        "leave_pay_out_policy",
      ]);
      unregister([
        "leave_crediting_schedule",
        "leave_per_leave_period",
        "leave_pay_out_policy",
      ]);
    }
    if (getValues("leave_pay_out_policy") === "Accumulate and carry forward") {
      setValue("leave_pay_out_policy", "Payout at the end of leave period");
      setLeavePayoutPolicy("Payout at the end of leave period");
    }
  };
  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(createLeaveType)}>
        <Mui.Grid
          container
          sx={{
            padding: 2,
            paddingLeft: { xs: 2, md: 6, lg: 10 },
            paddingRight: { xs: 2, md: 6, lg: 10 },
            paddingTop: 1,
          }}
        >
          <Mui.Grid
            container
            sx={{
              padding: 1,
              backgroundColor: themes.primary,
              borderRadius: "10px 10px 0 0",
              border: `2px solid ${themes.sidebarDivider}`,
              borderBottom: "none",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Mui.Typography sx={formHeader}>
              Edit Leave Type Configuration
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid
            container
            sx={{
              paddingTop: 1,
              paddingLeft: 5,
              paddingRight: 5,
              borderRadius: "0 0 10px 10px",
              border: `2px solid ${themes.sidebarDivider}`,
              display: "flex",
              justifyContent: "center",
              maxHeight: "calc(100vh - 220px)",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Mui.Grid container>
              {editLeaveTypeDetails?.version === 1 ? null : (
                <Mui.Grid
                  container
                  sx={{
                    borderRadius: 2,
                    padding: 2,
                    border: `2px solid ${themes.sidebarDivider}`,
                  }}
                >
                  <Mui.Grid xs={4}>
                    <Mui.Typography sx={tableData}>
                      Version :{" "}
                      {editLeaveTypeDetails?.pre_version_data?.pre_version}
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={4}>
                    <Mui.Typography sx={tableData}>
                      Effective From :{" "}
                      {
                        editLeaveTypeDetails?.pre_version_data
                          ?.pre_ver_effective_from
                      }
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={4}>
                    <Mui.Typography sx={tableData}>
                      Effective To : {watch("pre_ver_effective_to")}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>
              )}
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingBottom: 1 }}>
              <Mui.Grid xs={6}>
                <Mui.Typography sx={formKeyText}>
                  Leave Type Name &nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Specify or update the name of the leave type, such as Annual Leave, Sick Leave, or Maternity Leave."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={6} sx={{ paddingTop: 1.5 }}>
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title={viewDetails?.name}
                >
                  <Mui.Typography
                    sx={{
                      width: "200px", // Set a fixed width
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {viewDetails?.name}
                  </Mui.Typography>
                </Mui.Tooltip>
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingBottom: 1 }}>
              <Mui.Grid xs={6}>
                <Mui.Typography sx={formKeyText}>
                  Version &nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Indicates the version of the leave type configuration. Used to track modifications and updates."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={6}>
                <Mui.Typography sx={{ paddingTop: 1.7 }}>
                  {editLeaveTypeDetails?.version}
                </Mui.Typography>
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingBottom: 1 }}>
              <Mui.Grid xs={6}>
                <Mui.Typography sx={formKeyText}>
                  Effective From &nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Set the date when the updated leave type configuration will take effect."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={4} sx={{ paddingTop: 0.5 }}>
                <Mui.TextField
                  id="from-date"
                  type="date"
                  size="small"
                  {...register("effective_from", {
                    required: "Effect from date is required.",
                  })}
                  error={Boolean(errors.effective_from)}
                  helperText={
                    errors.effective_from?.message &&
                    errors.effective_from?.message
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(event) => {
                    setValue(
                      "pre_ver_effective_to",
                      dayjs(new Date(event.target.value))
                        .subtract(1, "day")
                        .format("DD-MM-YYYY")
                    );
                  }}
                  inputProps={{
                    // readOnly: true,
                    min: new Date(
                      editLeaveTypeDetails?.pre_version_data
                        ?.pre_ver_effective_to
                        ? editLeaveTypeDetails?.pre_version_data
                            ?.pre_ver_effective_to
                        : null
                    )
                      .toISOString()
                      .split("T")[0],
                  }}
                  fullWidth
                  disableOpenPicker
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={6}>
                <Mui.Typography sx={formKeyText}>
                  Proportion leave on joining date &nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Enable this to allocate leave proportionally based on the employee’s joining date."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>{" "}
              </Mui.Grid>
              <Mui.Grid xs={6}>
                <Mui.Switch
                  checked={proportionate}
                  onChange={updateProportionate}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={6}>
                <Mui.Typography sx={formKeyText}>
                  The required minimum notice period for this leave type&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Define the minimum notice period employees must provide before applying for this leave type."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={4}>
                <Mui.TextField
                  size="small"
                  {...register("min_days_to_apply", {
                    required: "Minumum notice period is required",
                  })}
                  error={errors.min_days_to_apply ? true : false}
                  helperText={errors.min_days_to_apply?.message}
                  value={watch("min_days_to_apply")}
                  onChange={(event) => {
                    if (
                      parseInt(event.target.value) <= 12 ||
                      event.target.value === ""
                    ) {
                      setValue("min_days_to_apply", event.target.value);
                    }
                  }}
                  onKeyPress={handleKeyPressWithYear}
                  fullWidth
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={6}>
                <Mui.Typography sx={formKeyText}>
                  Is this leave type paid ? &nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Enable this if employees are eligible for paid leave under this leave type."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={4}>
                <Mui.Grid container>
                  <Mui.Grid xs={2}>
                    <Mui.Switch
                      checked={isPaidLeave}
                      onChange={handlePaidLeaveOrNot}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </Mui.Grid>
                  {isPaidLeave ? (
                    <>
                      <Mui.Grid xs={7}>
                        <Mui.Typography sx={formKeyText}>
                          Payment Factor{" "}
                          <Mui.Tooltip
                            arrow
                            slotProps={tooltipStyleProps}
                            title="Specify the multiplier used for payment calculation during leave (e.g., 1.0 for full pay, 0.5 for half pay)."
                          >
                            <Info />
                          </Mui.Tooltip>
                        </Mui.Typography>
                      </Mui.Grid>
                      <Mui.Grid xs={3}>
                        <Mui.TextField
                          size="small"
                          {...register("payment_factor", {
                            required: false,
                            validate: {
                              atleastOneCharacterWithSpaceReg: (value) =>
                                isPaidLeave && !value
                                  ? "Payment factor is required"
                                  : true,
                            },
                          })}
                          placeholder="Enter payment factor"
                          error={errors.payment_factor ? true : false}
                          helperText={errors.payment_factor?.message}
                          value={paymentFactor}
                          inputProps={{ style: { textAlign: "center" } }}
                          onChange={(event) => {
                            const rgxWithDot = /^([0-9]{1,2})(\.[0-9]{0,2})?$/;
                            if (
                              (rgxWithDot.test(event.target.value) &&
                                parseInt(event.target.value) <= 1 &&
                                event.target.value.length <= 6) ||
                              event.target.value === ""
                            ) {
                              setPaymentFactor(event.target.value);
                              setValue("payment_factor", event.target.value);
                            }
                          }}
                        />
                      </Mui.Grid>
                    </>
                  ) : null}
                </Mui.Grid>
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={6}>
                <Mui.Typography sx={formKeyText}>
                  Enable auto leave creating&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Enable automatic leave crediting based on the defined schedule."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={6}>
                <Mui.Switch
                  checked={watch("enable_leave_crediting")}
                  onChange={updateEnableLeaveCrediting}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Mui.Grid>
            </Mui.Grid>
            {watch("enable_leave_crediting") ? (
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid xs={6}>
                  <Mui.Typography sx={formKeyText}>
                    Leave Crediting Schedule &nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Select the frequency at which leave is credited, such as monthly, quarterly, or annually."
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={4}>
                  <CustomAutoComplete
                    dataList={leaveCreditingShedule}
                    selectedValue={leaveCreditingSheduleData}
                    rules={{
                      ...register("leave_crediting_schedule", {
                        required: false,
                        validate: {
                          atleastOneCharacterWithSpaceReg: (value) =>
                            watch("enable_leave_crediting") && !value
                              ? "Leave creaditing Schedule is required"
                              : true,
                        },
                      }),
                    }}
                    updateDataFunction={handleLeaveCreditingSchedule}
                    placeHolder="Select the leave crediting schedule"
                    errorMessage={
                      errors?.leave_crediting_schedule?.message
                        ? errors?.leave_crediting_schedule?.message
                        : ""
                    }
                    textBoxError={
                      errors.leave_crediting_schedule ? true : false
                    }
                  />
                </Mui.Grid>
              </Mui.Grid>
            ) : null}
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={6}>
                <Mui.Typography sx={formKeyText}>
                  Leave Per Leave period &nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Specify how much leave is credited within each leave cycle (e.g., 2 days per month)."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={4}>
                <Mui.TextField
                  placeholder="Enter the leave Count"
                  {...register("leave_per_leave_period", {
                    required: "Leave count is required",
                  })}
                  size="small"
                  InputProps={{
                    inputProps: { maxLength: 4 },
                  }}
                  onChange={(event) => {
                    setAnnualLeaveCount(
                      parseFloat(
                        parseFloat(event.target.value || 0) *
                          (watch("enable_leave_crediting")
                            ? scheduleMultiplier[
                                watch("leave_crediting_schedule")
                              ] || 1
                            : 1)
                      ).toFixed(2)
                    );
                  }}
                  error={Boolean(errors.leave_per_leave_period)}
                  helperText={errors.leave_per_leave_period?.message || ""}
                  onKeyPress={handleKeyPress}
                  fullWidth
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={6}>
                <Mui.Typography sx={formKeyText}>
                  Is Week-off Sandwich Leave&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Enable this to count week-off days as leave when they fall within the selected sandwich rule."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={6}>
                <Mui.Switch
                  checked={watch("is_week_off_rule_apply")}
                  onChange={(event) => {
                    const checked = event.target.checked;
                    setValue("is_week_off_rule_apply", checked);
                    if (!checked) {
                      setValue("week_off_rule_type", "before");
                    }
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Mui.Grid>
            </Mui.Grid>
            {watch("is_week_off_rule_apply") && (
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid xs={6}>
                  <Mui.Typography sx={formKeyText}>
                    Is Week-off Sandwich Rule Type&nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Choose whether the week-off day should be counted before the leave, after the leave, on both sides, or in any matching case."
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={6}>
                  <Mui.RadioGroup
                    row
                    value={watch("week_off_rule_type")}
                    onChange={(event) =>
                      setValue("week_off_rule_type", event.target.value)
                    }
                  >
                    <Mui.FormControlLabel
                      value="before"
                      control={<Mui.Radio />}
                      label="Before"
                    />
                    <Mui.FormControlLabel
                      value="after"
                      control={<Mui.Radio />}
                      label="After"
                    />
                    <Mui.FormControlLabel
                      value="both"
                      control={<Mui.Radio />}
                      label="Both"
                    />
                    <Mui.FormControlLabel
                      value="any"
                      control={<Mui.Radio />}
                      label="Any"
                    />
                  </Mui.RadioGroup>
                </Mui.Grid>
              </Mui.Grid>
            )}
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={6}>
                <Mui.Typography sx={formKeyText}>
                  Is Holiday Sandwich Leave&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Enable this to count holiday days as leave when they fall within the selected sandwich rule."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={6}>
                <Mui.Switch
                  checked={watch("is_holiday_rule_apply")}
                  onChange={(event) => {
                    const checked = event.target.checked;
                    setValue("is_holiday_rule_apply", checked);
                    if (!checked) {
                      setValue("holiday_off_rule_type", "before");
                    }
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Mui.Grid>
            </Mui.Grid>
            {watch("is_holiday_rule_apply") && (
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid xs={6}>
                  <Mui.Typography sx={formKeyText}>
                    Is Holiday Sandwich Rule Type&nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Choose whether the holiday should be counted before the leave, after the leave, on both sides, or in any matching case."
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={6}>
                  <Mui.RadioGroup
                    row
                    value={watch("holiday_off_rule_type")}
                    onChange={(event) =>
                      setValue("holiday_off_rule_type", event.target.value)
                    }
                  >
                    <Mui.FormControlLabel
                      value="before"
                      control={<Mui.Radio />}
                      label="Before"
                    />
                    <Mui.FormControlLabel
                      value="after"
                      control={<Mui.Radio />}
                      label="After"
                    />
                    <Mui.FormControlLabel
                      value="both"
                      control={<Mui.Radio />}
                      label="Both"
                    />
                    <Mui.FormControlLabel
                      value="any"
                      control={<Mui.Radio />}
                      label="Any"
                    />
                  </Mui.RadioGroup>
                </Mui.Grid>
              </Mui.Grid>
            )}
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={6}>
                <Mui.Typography sx={formKeyText}>
                  Total Number of Annual Leave&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Specifies the total number of leave days an employee is eligible to avail annually under this leave type."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={6} sx={{ paddingTop: 2 }}>
                <Mui.Typography>{annualLeaveCount}</Mui.Typography>
              </Mui.Grid>
            </Mui.Grid>
            {watch("enable_leave_crediting") ? (
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid xs={6} sx={{ paddingTop: 1 }}>
                  <Mui.Typography sx={formKeyText}>
                    Leave payout policy &nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="ToDO"
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>{" "}
                </Mui.Grid>
                <Mui.Grid xs={4} sx={{ paddingTop: 1 }}>
                  <CustomAutoComplete
                    dataList={leavePayout}
                    rules={{
                      ...register("leave_pay_out_policy", {
                        required: false,
                        validate: {
                          atleastOneCharacterWithSpaceReg: (value) =>
                            watch("enable_leave_crediting") && !value
                              ? "Leave payout policy is required"
                              : true,
                        },
                      }),
                    }}
                    selectedValue={leavePayoutPolicyName}
                    updateDataFunction={updateLeavePayoutPolicy}
                    placeHolder="Select leave payout policy"
                    errorMessage={
                      errors?.leave_pay_out_policy?.message
                        ? errors?.leave_pay_out_policy?.message
                        : ""
                    }
                    textBoxError={errors?.leave_pay_out_policy ? true : false}
                  />
                </Mui.Grid>
              </Mui.Grid>
            ) : null}
            {leavePayoutPolicyName === "Accumulate and carry forward" &&
            watch("enable_leave_crediting") ? (
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid xs={6}>
                  <Mui.Typography sx={formKeyText}>
                    Max number of days can be carry forward &nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Update the maximum limit of carry-forward leave days based on revised policies. This ensures compliance with the latest leave entitlement rules."
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>{" "}
                </Mui.Grid>
                <Mui.Grid xs={4}>
                  <CustomTextBox
                    selectedValue={carryForwardDays}
                    rules={{
                      ...register("no_of_days_leave_carry_forward", {
                        required: false,
                        validate: {
                          atleastOneCharacterWithSpaceReg: (value) =>
                            leavePayoutPolicyName ===
                              "Accumulate and carry forward" && !value
                              ? "Carry forward days are required"
                              : true,
                          checkLessthenAnnualLeave: (value) =>
                            leavePayoutPolicyName ===
                              "Accumulate and carry forward" &&
                            (value === "0" || value === 0)
                              ? "The required minimum notice period for this leave type"
                              : true,
                        },
                      }),
                    }}
                    updateDataFunction={updateCarryForwardDays}
                    placeHolder="Enter the days"
                    errorMessage={
                      errors?.no_of_days_leave_carry_forward?.message
                        ? errors?.no_of_days_leave_carry_forward?.message
                        : ""
                    }
                    textBoxError={
                      errors?.no_of_days_leave_carry_forward ? true : false
                    }
                  />
                </Mui.Grid>
              </Mui.Grid>
            ) : null}
            {leavePayoutPolicyName === "Accumulate and carry forward" &&
            watch("enable_leave_crediting") ? (
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid xs={6}>
                  <Mui.Typography sx={formKeyText}>
                    Expiry Duration in Month &nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Modify the validity duration (in months) for carried-forward leave. Once this period expires, unused carried-forward leave will be removed, aligning with updated leave policies.
"
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>{" "}
                </Mui.Grid>{" "}
                <Mui.Grid xs={4}>
                  <CustomAutoComplete
                    dataList={monthNumber}
                    rules={{
                      ...register("expiry_month", {
                        required: false,
                        validate: {
                          atleastOneCharacterWithSpaceReg: (value) =>
                            leavePayoutPolicyName ===
                              "Accumulate and carry forward" && !value
                              ? "Expire days is required."
                              : true,
                        },
                      }),
                    }}
                    selectedValue={watch("expiry_month")}
                    updateDataFunction={updateExpireDetails}
                    placeholder="Enter expire month"
                    errorMessage={
                      errors?.expiry_month?.message
                        ? errors?.expiry_month?.message
                        : ""
                    }
                    textBoxError={errors?.expiry_month ? true : false}
                  />
                </Mui.Grid>
              </Mui.Grid>
            ) : null}

            {/* loop configuraitons */}
            <Mui.Grid container sx={{ paddingTop: 3, paddingBottom: 1 }}>
              <Mui.Grid xs={9}></Mui.Grid>
              <Mui.Grid
                xs={3}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  position: "sticky",
                  bottom: 0,
                  backgroundColor: themes.whiteColor || "#fff",
                  paddingTop: 1,
                  paddingBottom: 1,
                }}
              >
                <CustomButton
                  actionName="Cancel"
                  typeName="button"
                  actionFuntion={() => {
                    setEditLeaveType(false);
                  }}
                />
                &nbsp; &nbsp;
                <CustomButton
                  actionName="Update"
                  typeName="submit"
                  disableAction={buttonLoader}
                />
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
      </form>
    </React.Fragment>
  );
};
